import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Message } from 'src/app/core/class/message';
import { Routes } from 'src/app/core/constants/routes';
import { AnonymousSignService } from 'src/app/core/services/anonymous-sign.service';
import { CommonService } from 'src/app/core/services/common.service';
import { ShortLinkService } from 'src/app/core/services/shortLink/short-link.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
@Component({
  selector: 'app-page-short-link',
  templateUrl: './page-short-link.component.html',
  styleUrls: ['./page-short-link.component.scss']
})
export class PageShortLinkComponent extends BaseComponent implements OnInit {

  public href: string = '';
  public linkHome: string = '';
  showContent = false;
  contractEnterpriseIdEncode: string;
  tenantIdEncode: string;
  constructor(
    private router: Router,
    public commonService: CommonService,
    public message: Message,
    private translate: TranslateService,
    private shortLinkService: ShortLinkService,
    private anonymousSignService: AnonymousSignService,
    private route: ActivatedRoute,
    ) {
    super(commonService, message);
   }

  ngOnInit() {
    // console.log(this.router.url);
    const typeNavigate = this.router.url.slice(1,2)

    if(typeNavigate === 'v') {
      this.navigationFullLinkSign();
    }
    else if(typeNavigate === 's') {
      if(this.router.url.split('/')[4] && this.router.url.split('/')[4][0] === 'n') {
        this.navigationFullLinkSignAnonymousWithCapCha();
      }else {
        this.navigationFullLinkSignAnonymous();
      }
    }
  }

  navigationFullLinkSign() {
    const url = this.router.url.slice(3, this.router.url.length);
    this.shortLinkService.getFullLink(url).subscribe(res => {
      if (res.code === '200') {
        if (res.data) {
          // this.router.navigate([res.data])
          document.location.href = this.getDomain() + res.data;
        } else {
          this.setLinkHomeValue();
        }
      } else {
        this.setLinkHomeValue();
      }
    });
  }

  navigationFullLinkSignAnonymous() {
    // const url = this.router.url.slice(3, this.router.url.length);
    // this.shortLinkService.getFullLinkAnonymous(url).subscribe(res => {
    //   if (res.code === '200') {
    //     if (res.data) {
    //       this.router.navigate([res.data])
    //     } else {
    //       this.setLinkHomeValue();
    //     }
    //   } else {
    //     this.setLinkHomeValue();
    //   }
    // });
    this.route.paramMap.subscribe(params => {
      this.contractEnterpriseIdEncode = params.get('enterpriseId');
      this.tenantIdEncode = params.get('tenantId');
          this.anonymousSignService.getHashKey(this.contractEnterpriseIdEncode,this.tenantIdEncode).subscribe(res => {
      if (res.code === '200') {
        if (res.data) {
          this.router.navigate([`sign-anonymous/${res.data.hashKey}/${res.data.tenantId}`])
        } else {
          this.setLinkHomeValue();
        }
      } else {
        this.setLinkHomeValue();
      }
    });
    });
  }
  navigationFullLinkSignAnonymousWithCapCha() {
    this.route.paramMap.subscribe(params => {
      this.contractEnterpriseIdEncode = params.get('enterpriseId');
      this.tenantIdEncode = params.get('tenantId');
          this.anonymousSignService.getHashKey(this.contractEnterpriseIdEncode,this.tenantIdEncode, this.contractEnterpriseIdEncode).subscribe(res => {
      if (res.code === '200') {
        if (res.data) {
        //   console.log('sign-anonymous',res.data);
          this.router.navigate([`sign-anonymous/${res.data.hashKey}/${res.data.tenantId}/${res.data.contractIdAndContractEnterpriseIdEncode}`]);
        } else {
          this.setLinkHomeValue();
        }
      } else {
        this.setLinkHomeValue();
      }
    });
    });
  }
  getDomain() {
    var url = window.location.href;
    var arr = url.split("/");
    var result = arr[0] + "//" + arr[2];
    return result;
  }

  /*
  * Get current URL an check to routerLink to the fit page
  */
  setLinkHomeValue() {
    this.href = this.router.url;
    this.showContent = true;
    if (this.href.includes(Routes.ENTERPRISE_HOME)) {
      this.linkHome = Routes.SLASH + Routes.ENTERPRISE_HOME;
    }
  }

  login() {
    this.router.navigate([Routes.SLASH + Routes.ENTERPRISE_LOGIN]);
  }

  /**
   * <pre>
   * <b>Method name: onChangeLanguage</b>
   * <b>Explanation: </b> Method setting change langauge
   * </pre>
   * @author GCS 2019/08/26 by phuongtq
   *
   */
  onChangeLanguage(languageSelected: string) {
    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
  }
}
